import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getAllTradingPlatforms = async (categoryId: number, assetId: number) => {
  const { data: platforms } = await supabase
    .from('trading_platforms_categories')
    .select('*')
    .eq('category_id', categoryId)

  const { data: exceptions } = await supabase
    .from('trading_platforms_assets_exceptions')
    .select('*')
    .eq('asset_id', assetId)

  const exceptionsIds = exceptions?.map((e) => e.trading_platform)

  const ids = platforms?.map((p) => p.trading_platform_id)
    .filter((id) => !exceptionsIds?.includes(id)) as string[]

  const { data, error } = await supabase
    .from('trading_platforms')
    .select('*')
    .in('id', ids)

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetAllTradingPlatformById(categoryId: number, assetId: number) {
  return useQuery({
    queryKey: ['useGetAllTradingPlatformById'],
    queryFn: () => getAllTradingPlatforms(categoryId, assetId),
    staleTime: 0,
    cacheTime: 0,
    enabled: !!categoryId,
  })
}
